<input
  id="value"
  type="selector"
  [ngClass]="{ inputcustom: hasParentClass}"
  [(ngModel)]="item"
  [ngbTypeahead]="search"
  [resultTemplate]="rt"
  [inputFormatter]="formatter"
  (selectItem)="selectedItem($event)"
  (focus)="onFocus($event)"
  (click)="onClick($event)"
  (keyup.enter)="onEnter($event)"
  (focusout)="onFocusOut($event)"
  [attr.disabled]="active ? '' : null"
  #instance="ngbTypeahead"l
/>
<div class="selectorSearchinputIconContainer">
  <em class="fas fa-chevron-down"></em>
</div>

<div>
  <ng-template #rt let-r="result" let-t="term">
    <ngb-highlight *ngIf="fields.length == 0" [result]="r" [term]="t">
    </ngb-highlight>
    <ngb-highlight
      *ngIf="fields.length == 1"
      [result]="r[fields[0]]"
      [term]="t"
    >
    </ngb-highlight>
    <ngb-highlight
      *ngIf="fields.length >= 2 && r[fields[1]]"
      [result]="r[fields[0]] + ' - ' + r[fields[1]]"
      [term]="t"
    >
    </ngb-highlight>
    <ngb-highlight
      *ngIf="fields.length >= 2 && !r[fields[1]]"
      [result]="r[fields[0]]"
      [term]="t"
    >
    </ngb-highlight>
  </ng-template>
</div>
